import React from 'react'

export default ({number}) => {
  if (number === 0) return null
  return (
    <span className='icon has-text-danger is-size-7'>
      <span className='fa-stack fa-sm'>
        <i className='fa-solid fa-bell fa-stack-2x'></i>
        <strong className='fa-stack-1x fa-inverse has-text-white' style={{fontFamily: 'sans-serif'}}>
          {number}
        </strong>
      </span>
    </span>
  )
}
